import React from 'react';

export default function IndexSectionHowItWorksLightReverse6() {
    return (
        <React.Fragment>
            <>
                <section className="py-10 bg-gray-50 overflow-hidden">
  <div className="container mx-auto px-4">
    <div className="py-16 px-8 bg-white rounded-3xl">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading max-w-xl mb-20 text-4xl md:text-5xl text-gray-900 font-black tracking-tight">We make things easy for your business</h2>
        <div className="flex flex-wrap -m-3">
          <div className="w-full md:w-1/2 lg:w-1/4 p-3">
            <div className="flex flex-wrap items-center -m-3 mb-2">
              <div className="w-auto p-3">
                <div className="flex items-center justify-center w-16 h-16 text-xl text-gray-900 font-black bg-gray-100 rounded-full">1</div>
              </div>
              <div className="flex-1 p-3">
                <div className="bg-gray-200 h-px" />
              </div>
            </div>
            <div className="md:w-3/4">
              <h3 className="font-heading mb-4 text-2xl text-gray-900 font-bold">Register</h3>
              <p className="text-gray-700 font-bold">Sign up, create your profile and organization</p>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-1/4 p-3">
            <div className="flex flex-wrap items-center -m-3 mb-2">
              <div className="w-auto p-3">
                <div className="flex items-center justify-center w-16 h-16 text-xl text-white font-black bg-blue-500 rounded-full">2</div>
              </div>
              <div className="flex-1 p-3">
                <div className="bg-gray-200 h-px" />
              </div>
            </div>
            <div className="md:w-3/4">
              <h3 className="font-heading mb-4 text-2xl text-gray-900 font-bold">Start uploading</h3>
              <p className="text-gray-700 font-bold">FilingIQ will help organize all your clients documents and keep their data secure</p>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-1/4 p-3">
            <div className="flex flex-wrap items-center -m-3 mb-2">
              <div className="w-auto p-3">
                <div className="flex items-center justify-center w-16 h-16 text-xl text-gray-900 font-black bg-gray-100 rounded-full">3</div>
              </div>
              <div className="flex-1 p-3">
                <div className="bg-gray-200 h-px" />
              </div>
            </div>
            <div className="md:w-3/4">
              <h3 className="font-heading mb-4 text-2xl text-gray-900 font-bold">Have an accounting question?</h3>
              <p className="text-gray-700 font-bold">Our built-in assistant will give you concise answers and summaries taken from reliable sources</p>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-1/4 p-3">
            <div className="flex flex-wrap items-center -m-3 mb-2">
              <div className="w-auto p-3">
                <div className="flex items-center justify-center w-16 h-16 text-xl text-gray-900 font-black bg-gray-100 rounded-full">4</div>
              </div>
              <div className="flex-1 lg:hidden p-3">
                <div className="bg-gray-200 h-px" />
              </div>
            </div>
            <div className="md:w-3/4">
              <h3 className="font-heading mb-4 text-2xl text-gray-900 font-bold">Relax</h3>
              <p className="text-gray-700 font-bold">Enjoy the automation FilingIQ provides and gain more time to advise, consult or gain new clients</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


            </>
        </React.Fragment>
    );
}

